module.exports = __webpack_public_path__ + "static/media/square-success-round-tick.1bd14530.svg";